import React from 'react'
import { useTypedSelector } from 'src/redux/index'
import {
  ContestCard,
  ContestFlex,
  ContestCardHeader,
  ContestCardBody,
  ContestImg,
} from '../style'
import { Link, useLocation } from 'react-router-dom'
import { addNairaSign } from 'src/utils/addNairaSign'
import { LinkArrowSvg } from 'src/assets'
import { ContestUsersSvg } from 'src/assets'

const AllContest = () => {
  const allContest = useTypedSelector((state) => state.xcontest.all)
  let location = useLocation()

  return (
    <ContestFlex>
      {allContest.map((item: any) => {
        return (
          <Link
            to={`/xcontest/contest-detail/${item.id}`}
            key={item.id}
            state={{ backgroundLocation: location }}
            className="contest_card_link"
          >
            <ContestCard key={item.id}>
              <ContestCardHeader>
                <ContestImg src={item.image} alt="" />
              </ContestCardHeader>
              <ContestCardBody>
                <div className="name_img">
                  <h3>{item.name}</h3>
                </div>
                <p>
                  <span>{addNairaSign(item.amount_to_save)}</span>
                  every month
                </p>
                <p>
                  <span>{addNairaSign(item.reward)}</span> reward
                </p>
                <div className="link_wrapper">
                  <Link to={`/xcontest/${item.id}`} className="contest_link">
                    join Contest <img src={LinkArrowSvg} alt="" />
                  </Link>
                </div>
              </ContestCardBody>
            </ContestCard>
          </Link>
        )
      })}
    </ContestFlex>
  )
}

export default AllContest
